<template>
  <Popover class="absolute inset-0">
    <PopoverButton class="absolute inset-0 flex justify-center items-center" @click="show">
      <EllipsisHorizontalIcon class="h-4 w-4 mr-1" />
    </PopoverButton>

    <transition-appear origin="center">
      <PopoverPanel v-if="isOpened" class="absolute top-[5px] right-[5px] w-screen max-w-max" static>
        <OnClickOutside @trigger="close">
          <div class="isolate inline-flex rounded-md shadow-lg *:first:rounded-l-md *:last:rounded-r-md">
            <a href="#" class="btn-list-action" @click.prevent="$emit('replay', row)">
              <BoltIcon class="mr-2 h-3 text-slate-400" />
              Replay
            </a>

            <router-link :to="`/stripe-webhook-events?search=${row.eventType}`" class="btn-list-action">
              <FunnelIcon class="mr-2 h-3 text-slate-400" />
              Type
            </router-link>

            <router-link :to="`/stripe-webhook-events?search=${row.processingState}`" class="btn-list-action">
              <FunnelIcon class="mr-2 h-3 text-slate-400" />
              State
            </router-link>

            <router-link :to="`/stripe-webhook-events?search=${row.userId}`" class="btn-list-action">
              <FunnelIcon class="mr-2 h-3 text-slate-400" />
              UserId
            </router-link>

            <router-link :to="`/stripe-webhook-events?search=${row.stripeCustomerId}`" class="btn-list-action">
              <FunnelIcon class="mr-2 h-3 text-slate-400" />
              Customer ID
            </router-link>
          </div>
        </OnClickOutside>
      </PopoverPanel>
    </transition-appear>
  </Popover>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import TransitionAppear from './TransitionAppear.vue';
import { EllipsisHorizontalIcon, FunnelIcon, BoltIcon } from '@heroicons/vue/24/outline';
import { OnClickOutside } from '@vueuse/components';

const props = defineProps({
  row: {
    type: Object,
    default: () => {}
  },
  index: {
    type: Number,
    default: null
  },
  isRowHovered: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([ 'replay' ]);

const isOpened = ref(false);

watch(() => props.isRowHovered, val => isOpened.value = val);

function show() {
  isOpened.value = true;
}

function close() {
  isOpened.value = false;
}
</script>
